import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CustomerBuilder } from '../../models/builders/customer-builder';
import { Customer } from '../../models/customer';
import { CustomersRequestInterface } from '../../models/request/customers-request.interfaces';
import { CustomerTypeBuilder } from '../../models/builders/customer-type-builder';

import { OptionBuilder } from '../../models/builders/option.builder';

const createCustomerBody = (customer: Customer) => (
  {
    businessName: customer.businessName,
    tradeName: customer.tradeName,
    tin: customer.tin,
    address: customer.address,
    deliveryAddress: customer.deliveryAddress,
    postCode: customer.postCode,
    city: customer.city,
    province: customer.province,
    country: customer.country,
    email: customer.email,
    phone: customer.phone,
    contactPerson: customer.contactPerson,
    contactPerson2: customer.contactPerson2,
    vat: customer.vat,
    customerTypeHash: customer.customerType
  }
);

@Injectable()
export class CustomerApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}customers`;
  }

  getCustomer(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(CustomerBuilder.fromJson)
    );
  }

  getCustomers() {
    return this.httpClient.get(this.apiUrl).pipe(map(CustomerBuilder.fromJsonList));
  }

  searchCustomers(query: string) {
    const params = new HttpParams().append('query', query ? query.toLowerCase() : '');

    return this.httpClient.get(`${ this.apiUrl }/search/options`, { params })
      .pipe(
        map(OptionBuilder.fromList)
      );
  }

  getCustomerTypes() {
    return this.httpClient.get(`${this.apiUrl}/customer-types`).pipe(map(CustomerTypeBuilder.fromJsonList));
  }

  createCustomer(customer: Customer) {
    return this.httpClient.post(`${this.apiUrl}`, createCustomerBody(customer)).pipe(
      map(CustomerBuilder.fromJson)
    );
  }

  updateCustomer(setting: Customer) {
    return this.httpClient.put(`${ this.apiUrl }/${ setting.hash }`, createCustomerBody(setting));
  }

  deleteCustomer(customerHash: string) {
    return this.httpClient.delete(`${ this.apiUrl }/${ customerHash }`);
  }

  getFilteredCustomers(request: CustomersRequestInterface)  {
    let params = new HttpParams();
    params = params.append('page', request.page.toString())
                   .append('itemsPerPage', request.itemsPerPage.toString())
                   .append('sortField', request.sortField)
                   .append('reverse', (!!request.reverse).toString());
    if (request.businessName) {
      params = params.append('businessName', request.businessName);
    }
    if (request.tin) {
      params = params.append('tin', request.tin);
    }

    return this.httpClient.get(`${this.apiUrl}/filter`, { params: params })
      .pipe(
        map(this.mapData)
      );
  }

  private mapData = (data) => {
    data.customers = CustomerBuilder.fromJsonList(data.customers);
    return data;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/customer-api.service.ts